const forgotPasswordValidationRules = {
  email: {
    email: {
      message: "^Please enter a valid email"
    }
  }
};

export default forgotPasswordValidationRules;
